module.exports = __webpack_public_path__ + "static/media/ghost.fcd03525.svg";